module.exports = __webpack_public_path__ + "static/media/24UHCHR15.27af1d17.jpg";